import React from 'react';
import { CheckCircle } from 'lucide-react';

const ProfileCompleteness = ({ profile, onEdit }) => {
  const checks = [
    { key: 'avatar', label: 'Photo de profil', done: !!profile.avatar && !profile.avatar.includes('ui-avatars.com') },
    { key: 'bio', label: 'Bio', done: !!profile.bio && profile.bio.length > 10 },
    { key: 'skills', label: 'Compétences', done: profile.skills?.length > 0 },
    { key: 'experience', label: 'Expérience', done: profile.experience?.length > 0 },
    { key: 'education', label: 'Formation', done: profile.education?.length > 0 },
    { key: 'social', label: 'Liens sociaux', done: !!(profile.linkedin_url || profile.twitter_url || profile.website) },
  ];

  const completed = checks.filter(c => c.done).length;
  const total = checks.length;
  const pct = Math.round((completed / total) * 100);
  const radius = 18;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (pct / 100) * circumference;

  if (pct === 100) return null;

  const nextStep = checks.find(c => !c.done);

  // Brief B5 P0 Bug 2b — le widget devient cliquable et ouvre la modal d'édition.
  const interactive = typeof onEdit === 'function';
  return (
    <button
      type="button"
      onClick={interactive ? onEdit : undefined}
      disabled={!interactive}
      className={`w-full flex items-center gap-3 mt-4 p-3 rounded-xl bg-gradient-to-r from-purple-50 to-indigo-50 dark:from-purple-900/15 dark:to-indigo-900/15 border border-purple-100 dark:border-purple-800/30 text-left transition-all ${
        interactive ? 'cursor-pointer hover:shadow-md hover:border-purple-300 dark:hover:border-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-400/60' : ''
      }`}
      data-testid="profile-completeness"
      aria-label={interactive ? `Compléter mon profil (${pct}%)` : undefined}
    >
      <div className="relative flex-shrink-0">
        <svg width="44" height="44" className="-rotate-90">
          <circle cx="22" cy="22" r={radius} fill="none" stroke="currentColor" strokeWidth="3" className="text-gray-200 dark:text-gray-700" />
          <circle cx="22" cy="22" r={radius} fill="none" stroke="url(#completeness-gradient)" strokeWidth="3" strokeLinecap="round"
            strokeDasharray={circumference} strokeDashoffset={offset}
            style={{ transition: 'stroke-dashoffset 0.8s ease-out' }}
          />
          <defs>
            <linearGradient id="completeness-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#8b5cf6" />
              <stop offset="100%" stopColor="#ec4899" />
            </linearGradient>
          </defs>
        </svg>
        <span className="absolute inset-0 flex items-center justify-center text-xs font-bold text-purple-700 dark:text-purple-300">
          {pct}%
        </span>
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-xs font-semibold text-gray-700 dark:text-gray-300">
          Profil complété à {pct}%
        </p>
        {nextStep && (
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5 flex items-center gap-1">
            Prochaine étape : <span className="font-medium text-purple-600 dark:text-purple-400">{nextStep.label}</span>
          </p>
        )}
      </div>
      <div className="flex gap-0.5 flex-shrink-0">
        {checks.map((c, i) => (
          <div key={i} className={`w-1.5 h-6 rounded-full ${c.done ? 'bg-purple-500' : 'bg-gray-200 dark:bg-gray-700'}`} title={c.label} />
        ))}
      </div>
    </button>
  );
};

export default ProfileCompleteness;
